import { jsx } from "react/jsx-runtime";
import Avatar from "@mui/material/Avatar";
import { getAvatarTint, getAvatarInitial } from "../utils/avatar.js";
function UserAvatar(props) {
  const { name, imageUrl, size = 40 } = props;
  const tint = getAvatarTint(name);
  return /* @__PURE__ */ jsx(
    Avatar,
    {
      src: imageUrl || void 0,
      sx: {
        flex: "none",
        width: size,
        height: size,
        bgcolor: tint.bg,
        color: tint.fg,
        fontSize: Math.round(size * 0.36),
        fontWeight: 700,
        letterSpacing: "-0.02em"
      },
      children: getAvatarInitial(name)
    }
  );
}
export {
  UserAvatar
};
